import VideosApi from '../api/VideosApi';
import VideosConstants from '../constants/VideosConstants';

function addVideo({ metadataId, url, title, description, postSuccess }) {
  return {
    metadataId,
    postSuccess,
    types: [
      VideosConstants.ADD_VIDEO_REQUEST,
      VideosConstants.ADD_VIDEO_SUCCESS,
      VideosConstants.ADD_VIDEO_FAILURE
    ],
    middlewareData: {
      authRequired: true
    },
    apiRequest: (state, client) => VideosApi.addVideo({
      metadataId,
      url,
      title,
      description,
      userId: state.getIn(['auth', 'currentUserId'])
    }, client)
  };
}

function updateVideo({ metadataId, videoId, url, title, description, postSuccess }) {
  return {
    metadataId,
    videoId,
    postSuccess,
    types: [
      VideosConstants.UPDATE_VIDEO_REQUEST,
      VideosConstants.UPDATE_VIDEO_SUCCESS,
      VideosConstants.UPDATE_VIDEO_FAILURE
    ],
    middlewareData: {
      authRequired: true
    },
    apiRequest: (state, client) => VideosApi.updateVideo({
      metadataId,
      videoId,
      url,
      title,
      description,
      userId: state.getIn(['auth', 'currentUserId'])
    }, client)
  };
}

function removeVideo(metadataId, videoId) {
  return {
    metadataId,
    videoId,
    types: [
      VideosConstants.REMOVE_VIDEO_REQUEST,
      VideosConstants.REMOVE_VIDEO_SUCCESS,
      VideosConstants.REMOVE_VIDEO_FAILURE
    ],
    middlewareData: {
      authRequired: true
    },
    apiRequest: (state, client) => VideosApi.removeVideo({
      videoId,
      userId: state.getIn(['auth', 'currentUserId'])
    }, client),
    apiSuccess: () => ({
      deletedEntities: [`ugc.videos.${videoId}`]
    })
  };
}

export default {
  addVideo,
  updateVideo,
  removeVideo
};



// WEBPACK FOOTER //
// ./app/actions/VideosActions.js